import React, { useState, useEffect } from 'react'
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Icon,
  Input,
  Row,
  Select,
  Table,
  message
} from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import { fetchAllBillReport, fetchAllReport } from '../../modules/reports'
import moment from 'moment'
import axios from 'axios'
import { groupBy, isEmpty, some } from 'lodash'
import { DATE, ENDPOINT } from '../../utils/constants'
import { ButtonEx } from '../../styles/button.style'
import WrappedBillForm from './components/BillForm'
import WrappedUserForm from './components/UserForm'
import '../../../node_modules/react-image-lightbox/style.css'
import styled from 'styled-components'
import Modal from 'antd/lib/modal'

const { RangePicker } = DatePicker

const today = () => moment().format(DATE.FORMAT)
const isOverOneMonth = (start, end) =>
  end.isAfter(moment(start).add(1, 'month'), 'day')
const joinOrAll = (value) =>
  isEmpty(value) || value[0] === 0 ? undefined : value.join()

const Transaction = ({ form, data }) => {
  const dispatch = useDispatch()
  const { validateFields, getFieldDecorator, getFieldValue } = form
  const [filterOptions, setFilterOptions] = useState({
    size: 20,
    page: 0,
    fromDate: today(),
    toDate: today()
  })
  const [rangeStart, setRangeStart] = useState(null)
  const [statusOption, setStatusOption] = useState(true)
  const [status, setStatus] = useState([])
  const [userNameOption, setUserNameOption] = useState(true)
  const [userName, setUserName] = useState([])
  const [heroNameOption, setHeroNameOption] = useState(true)
  const [heroName, setHeroName] = useState([])
  const [activityOption, setActivityOption] = useState(true)
  const [activity, setActivity] = useState([])
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})
  const [formDataBill, setFormDataBill] = useState({})
  const [loadingBillId, setLoadingBillId] = useState(null)
  const [visibleUser, setVisibleUser] = useState(false)
  const [formDataUser, setFormDataUser] = useState({})
  const [loadingUserId, setLoadingUserId] = useState(null)
  const [imageList, setImageList] = useState([])
  const MAX_IMAGES = 5

  const { transactionList, allList, isLoading } = useSelector(
    (state) => ({
      allList: state.reports.allList,
      transactionList: state.reports.allTransactionList,
      isLoading: state.reports.isLoading
    }),
    []
  )

  const ImageGallery = ({ images = [] }) => {
    const [validImages, setValidImages] = useState([])
    const [isPreviewOpen, setIsPreviewOpen] = useState(false)
    const [currentImageIndex, setCurrentImageIndex] = useState(0)

    useEffect(() => {
      const loadedImages = []
      let loadedCount = 0

      images.forEach((src, index) => {
        const img = new Image()
        img.onload = () => {
          loadedImages.push(src)
          loadedCount++
          if (loadedCount === images.length) {
            setValidImages(loadedImages)
          }
        }
        img.onerror = () => {
          loadedCount++
          if (loadedCount === images.length) {
            setValidImages(loadedImages)
          }
        }
        img.src = src
      })
    }, [images])

    if (!validImages.length) {
      return <p>ไม่มีรูปภาพ</p>
    }

    const openPreview = (index) => {
      setCurrentImageIndex(index)
      setIsPreviewOpen(true)
    }

    return (
      <div>
        <GalleryContainer>
          {validImages.slice(0, MAX_IMAGES).map((image, index) => (
            <ImageBox key={index} onClick={() => openPreview(index)}>
              <img src={image} alt={`cover-${index}`} />
            </ImageBox>
          ))}
          {validImages.length > MAX_IMAGES && (
            <MoreButton onClick={() => openPreview(0)}>ดูรูปภาพ</MoreButton>
          )}
        </GalleryContainer>
        <Modal
          visible={isPreviewOpen}
          footer={null}
          onCancel={() => setIsPreviewOpen(false)}
          centered
          closable={false}
          width={800}>
          <PreviewImageContainer>
            <img
              src={validImages[currentImageIndex]}
              alt={`preview-${currentImageIndex}`}
            />
          </PreviewImageContainer>
          <ThumbnailContainer>
            {validImages.map((image, index) => (
              <ThumbnailBox
                key={index}
                onClick={() => setCurrentImageIndex(index)}>
                <img src={image} alt={`thumb-${index}`} />
              </ThumbnailBox>
            ))}
          </ThumbnailContainer>
        </Modal>
      </div>
    )
  }

  async function fetchData(options = filterOptions) {
    setFilterOptions(options)
    await dispatch(
      fetchAllReport({ fromDate: options.fromDate, toDate: options.toDate })
    )
    await dispatch(fetchAllBillReport(options))
  }

  async function fetchPage(options) {
    setFilterOptions(options)
    await dispatch(fetchAllBillReport(options))
  }

  useDeepEffect(() => {
    form.setFieldsValue({
      status: [0],
      userName: [0],
      heroName: [0],
      activityName: [0]
    })
    fetchData()
  }, [])

  useDeepEffect(() => {
    setStatusSelect()
    setUserNameSelect()
    setHeroNameSelect()
    setSelectActivity()
  }, [allList])

  useDeepEffect(() => {
    if (!isEmpty(transactionList)) {
      setImageBill()
    }
  }, [transactionList])

  async function setStatusSelect() {
    const arr = groupBy(allList, 'status')
    const results = []
    for (const item of Object.keys(arr)) {
      if (item !== 'null') {
        results.push({
          status: item
        })
      }
    }
    setStatus(results)
  }
  async function setUserNameSelect() {
    const arr = groupBy(allList, 'userName')
    const results = []
    for (const item of Object.keys(arr)) {
      if (item !== 'null') {
        results.push({
          userName: item
        })
      }
    }
    setUserName(results)
  }
  async function setHeroNameSelect() {
    const arr = groupBy(allList, 'heroName')
    const results = []
    for (const item of Object.keys(arr)) {
      if (item !== 'null') {
        results.push({
          heroName: item
        })
      }
    }
    setHeroName(results)
  }

  async function setImageBill() {
    const groupedByReference = groupBy(transactionList.content, 'referenceCode')

    const results = Object.entries(groupedByReference).map(
      ([referenceCode, transactions]) => ({
        referenceCode,
        images: transactions.flatMap((t) =>
          Array.isArray(t.imageBillItemList) ? t.imageBillItemList : []
        )
      })
    )

    setImageList(results)
  }

  async function setSelectActivity() {
    const arr = groupBy(allList, 'brandActivity')
    const results = []
    for (const item of Object.keys(arr)) {
      if (item !== 'null') {
        results.push({
          activity: item
        })
      }
    }
    setActivity(results)
  }

  async function onShowSizeChange(current, pageSize) {
    await fetchPage({ ...filterOptions, size: pageSize, page: 0 })
  }

  async function onChange(page, pageSize) {
    await fetchPage({
      ...filterOptions,
      size: pageSize || filterOptions.size,
      page: page - 1
    })
  }

  function disabledDate(current) {
    if (!current) {
      return false
    }
    if (current.isAfter(moment(), 'day')) {
      return true
    }
    if (!rangeStart) {
      return false
    }
    return (
      isOverOneMonth(rangeStart, current) ||
      isOverOneMonth(current, rangeStart)
    )
  }

  function exportUrl() {
    const range = getFieldValue('dateRange')
    const fromDate = range
      ? range[0].format(DATE.FORMAT)
      : filterOptions.fromDate
    const toDate = range ? range[1].format(DATE.FORMAT) : filterOptions.toDate
    return ENDPOINT + `/bin/export-admin-all?&from=${fromDate}&to=${toDate}`
  }

  function validateDateRange(rule, value, callback) {
    if (value && value.length === 2 && isOverOneMonth(value[0], value[1])) {
      callback('เลือกช่วงวันที่ได้ไม่เกิน 1 เดือน')
    } else {
      callback()
    }
  }
  const onClick = async (e, record) => {
    e.preventDefault()
    if (loadingBillId) {
      return
    }
    setLoadingBillId(record.billId)
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_ENDPOINT + `/recycle/bill/` + record.billId
      )
      setFormDataBill(res.data)
      setFormData(record)
      setVisible(true)
    } catch (err) {
      message.error('โหลดรายละเอียดบิลไม่สำเร็จ')
    } finally {
      setLoadingBillId(null)
    }
  }

  const onCloseModal = (changed) => {
    setVisible(false)
    if (changed === true) {
      fetchData()
    }
  }

  const onClickUser = async (e, record) => {
    e.preventDefault()
    if (record.userId == 0 || loadingUserId) {
      return
    }
    setLoadingUserId(record.userId)
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_ENDPOINT + `/login/` + record.userId
      )
      setFormDataUser(res.data.data)
      setVisibleUser(true)
    } catch (err) {
      message.error('โหลดข้อมูลผู้ส่งต่อไม่สำเร็จ')
    } finally {
      setLoadingUserId(null)
    }
  }

  const onCloseModalUser = async () => {
    await setVisibleUser(false)
  }

  const GetDate = (time) => {
    let date = ''
    if (time !== null) {
      date = moment(time).format('DD/MM/YYYY')
    }
    return date
  }

  function handleStatusChange(value) {
    const isAll = some(value, (item) => {
      return item === 'all'
    })
    if (isAll) {
      setStatusOption(true)
    } else {
      setStatusOption(false)
    }
  }

  function handleUserNameChange(value) {
    const isAll = some(value, (item) => {
      return item === 'all'
    })
    if (isAll) {
      setUserNameOption(true)
    } else {
      setUserNameOption(false)
    }
  }

  function handleHeroNameChange(value) {
    const isAll = some(value, (item) => {
      return item === 'all'
    })
    if (isAll) {
      setHeroNameOption(true)
    } else {
      setHeroNameOption(false)
    }
  }

  function handleActivityChange(value) {
    const isAll = some(value, (item) => {
      return item === 'all'
    })
    if (isAll) {
      setActivityOption(true)
    } else {
      setActivityOption(false)
    }
  }
  const columns = [
    {
      title: 'ลำดับ',
      render: (text, record, index) => (
        <span>{filterOptions.page * filterOptions.size + index + 1}</span>
      )
    },
    {
      title: 'เลขอ้างอิง',
      dataIndex: 'referenceCode',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'วันที่ทำการส่งต่อ',
      dataIndex: 'date',
      align: 'center',
      render: (date) => {
        const start = GetDate(date)
        return <span>{start}</span>
      }
    },
    {
      title: 'จำนวนรายการที่ส่งต่อ',
      dataIndex: 'itemCount',
      align: 'center',
      width: 80,
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'สถานะ',
      dataIndex: 'status',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'กิจกรรม',
      dataIndex: 'brandActivity',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'ผู้ส่งต่อ',
      dataIndex: 'userName',
      align: 'center',
      render: (text, record) => (
        <span>
          {' '}
          {text ? (
            <div>
              <a
                onClick={(e) => {
                  onClickUser(e, record)
                }}>
                {text}
              </a>
              {loadingUserId === record.userId && <Icon type="loading" />}
            </div>
          ) : (
            '-'
          )}
        </span>
      )
    },
    {
      title: 'ผู้รับ',
      dataIndex: 'heroName',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'รูปภาพหลักฐาน',
      dataIndex: 'imageBillItemList',
      align: 'center',
      render: (text, record) => {
        const images =
          imageList.length > 0
            ? imageList
                .filter((t) => t.referenceCode === record.referenceCode)
                .flatMap((t) => t.images)
            : []

        return (
          <div
            style={{
              padding: '10px',
              minHeight: 60,
              display: 'flex',
              alignItems: 'center'
            }}>
            {images.length > 0 ? (
              <ImageGallery images={images} />
            ) : (
              <span
                style={{
                  minHeight: 40,
                  display: 'flex',
                  alignItems: 'center'
                }}>
                กำลังโหลดข้อมูล...
              </span>
            )}
          </div>
        )
      }
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 80,
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="eye"
            loading={loadingBillId === record.billId}
            disabled={!!loadingBillId && loadingBillId !== record.billId}
            onClick={(e) => {
              onClick(e, record)
            }}
          />
        </span>
      )
    }
  ]

  const onClear = async (e) => {
    e.preventDefault()
    form.setFieldsValue({
      dateRange: [moment(), moment()],
      referenceCode: '',
      status: [0],
      userName: [0],
      heroName: [0],
      activityName: [0]
    })
    setStatusOption(true)
    setUserNameOption(true)
    setHeroNameOption(true)
    setActivityOption(true)

    await fetchData({ size: 20, page: 0, fromDate: today(), toDate: today() })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        await fetchData({
          size: filterOptions.size,
          page: 0,
          fromDate: values.dateRange[0].format(DATE.FORMAT),
          toDate: values.dateRange[1].format(DATE.FORMAT),
          referenceCode: values.referenceCode || undefined,
          status: joinOrAll(values.status),
          userName: joinOrAll(values.userName),
          heroName: joinOrAll(values.heroName),
          activityName: joinOrAll(values.activityName)
        })
      }
    })
  }
  return (
    <Row type="flex" gutter={[8, 8]}>
      <Col span={24}>
        <Card>
          <Form
            form={form}
            layout="vertical"
            colon={false}
            onSubmit={handleSubmit}>
            <Row gutter={8}>
              <Col span={24}>
                <Row gutter={8}>
                  <Col xs={24} sm={24} md={24} lg={12} xl={6}>
                    <Form.Item label="ช่วงวันที่">
                      {getFieldDecorator('dateRange', {
                        initialValue: [moment(), moment()],
                        rules: [
                          {
                            required: true,
                            message: 'กรุณาเลือกช่วงวันที่'
                          },
                          { validator: validateDateRange }
                        ]
                      })(
                        <RangePicker
                          allowClear={false}
                          format="DD/MM/YYYY"
                          style={{ width: '100%' }}
                          disabledDate={disabledDate}
                          onCalendarChange={(dates) =>
                            setRangeStart(
                              dates && dates.length === 1 ? dates[0] : null
                            )
                          }
                          onOpenChange={(open) => {
                            if (!open) {
                              setRangeStart(null)
                            }
                          }}
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={6}>
                    <Form.Item label="เลขอ้างอิง">
                      {getFieldDecorator('referenceCode')(
                        <Input placeholder="เลขอ้างอิง" />
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={6}>
                    <Form.Item label="สถานะ">
                      {getFieldDecorator('status')(
                        <Select
                          allowClear={true}
                          mode="multiple"
                          showSearch={true}
                          onChange={handleStatusChange}
                          showArrow={true}
                          filterOption={false}
                          notFoundContent={null}>
                          <Select.Option value={0}>ทั้งหมด</Select.Option>
                          {status.map((status, index) => {
                            return (
                              <Select.Option
                                key={index}
                                value={status.status}
                                disabled={statusOption}>
                                {status.status}
                              </Select.Option>
                            )
                          })}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={6}>
                    <Form.Item label="กิจกรรม">
                      {getFieldDecorator('activityName')(
                        <Select
                          allowClear={true}
                          mode="multiple"
                          showSearch={true}
                          onChange={handleActivityChange}
                          showArrow={true}
                          filterOption={false}
                          notFoundContent={null}>
                          <Select.Option value={0}>ทั้งหมด</Select.Option>
                          {activity.map((activity, index) => {
                            return (
                              <Select.Option
                                key={index}
                                value={activity.activity}
                                disabled={activityOption}>
                                {activity.activity}
                              </Select.Option>
                            )
                          })}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={6}>
                    <Form.Item label="ผู้ส่งต่อ">
                      {getFieldDecorator('userName')(
                        <Select
                          allowClear={true}
                          mode="multiple"
                          showSearch={true}
                          onChange={handleUserNameChange}
                          showArrow={true}
                          notFoundContent={null}>
                          <Select.Option value={0}>ทั้งหมด</Select.Option>
                          {userName.map((userName, index) => {
                            return (
                              <Select.Option
                                key={index}
                                value={userName.userName}
                                disabled={userNameOption}>
                                {userName.userName}
                              </Select.Option>
                            )
                          })}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={6}>
                    <Form.Item label="ผู้รับ">
                      {getFieldDecorator('heroName')(
                        <Select
                          allowClear={true}
                          mode="multiple"
                          showSearch={true}
                          onChange={handleHeroNameChange}
                          showArrow={true}
                          filterOption={false}
                          notFoundContent={null}>
                          <Select.Option value={0}>ทั้งหมด</Select.Option>
                          {heroName.map((heroName, index) => {
                            return (
                              <Select.Option
                                key={index}
                                value={heroName.heroName}
                                disabled={heroNameOption}>
                                {heroName.heroName}
                              </Select.Option>
                            )
                          })}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12} xl={6}>
                    <Form.Item label="" style={{ marginTop: '1.75rem' }}>
                      <Row gutter={8} type="flex" justify="start">
                        <Col>
                          <Button type="primary" htmlType="submit">
                            ค้นหา
                          </Button>
                        </Col>
                        <Col>
                          <Button type="danger" onClick={(e) => onClear(e)}>
                            เคลียร์
                          </Button>
                        </Col>
                        <Col>
                          <ButtonEx color="#6ebf4b" type="primary">
                            <a
                              href={exportUrl()}
                              download>
                              Export Data
                            </a>
                          </ButtonEx>
                        </Col>
                      </Row>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </Card>
      </Col>
      <Col span={24}>
        <Table
          rowKey={(record) => {
            return record.id
          }}
          bordered
          dataSource={transactionList.content}
          columns={columns}
          loading={isLoading}
          pagination={{
            current: !isEmpty(transactionList)
              ? transactionList.pageable.pageNumber + 1
              : 1,
            pageSize: transactionList.size,
            pageSizeOptions: ['10', '20', '50', '100'],
            showSizeChanger: true,
            onShowSizeChange: onShowSizeChange,
            onChange: onChange,
            total: transactionList.totalElements,
            showTotal: (total) => `ทั้งหมด ${total} รายการ`
          }}
          scroll={{ x: 'max-content' }}
        />
        <WrappedBillForm
          visible={visible}
          onCancel={onCloseModal}
          formData={formData}
          formDataBill={formDataBill}
        />
        <WrappedUserForm
          visible={visibleUser}
          onCancel={onCloseModalUser}
          formData={formDataUser}
        />
      </Col>
    </Row>
  )
}

const WrappedTransaction = Form.create({
  name: 'WrappedTransaction'
})(Transaction)

export default WrappedTransaction

const GalleryContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const ImageBox = styled.div`
  width: 40px;
  height: 40px;
  background-color: #e5e7eb;
  border-radius: 8px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

const MoreButton = styled.button`
  color: #3b82f6;
  font-size: 11px;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  outline: none;
  white-space: nowrap;
`

const PreviewImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 400px;
  background-color: #f0f0f0;
  padding: 10px 0;
  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`

const ThumbnailContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 10px;
`

const ThumbnailBox = styled.div`
  width: 50px;
  height: 50px;
  border: 2px solid transparent;
  cursor: pointer;
  transition: border 0.3s ease;

  &:hover {
    border-color: #3b82f6;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`
